import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

const AddressedRoute = ({ component: Component, ...rest }) => {
  const address = useSelector(state => state.address)
  const territory = useSelector(state => state.territory)
  const userType = window.location.pathname.includes('hosts') ? 'host' : 'guest'
  const signupCheckEnabled = territory[`${userType}_address_check`]
  
  return(
    <Route {...rest} render={props => (
      address || !signupCheckEnabled
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/' }} />
    )} />
  )
}

export default AddressedRoute
